import React from "react";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { useData } from "@/context/DataContext";

const OPCIONES = [
  ["ambas", "Mostrar los dos botones", "Abrir en mi correo y Abrir en Gmail"],
  ["predeterminada", "App de correo predeterminada", "La que tenga configurada el móvil (Mail, Outlook…)"],
  ["gmail", "Gmail", "Abre Gmail directamente"],
];

// Perfil › Mi app de correo: qué botones salen en las gestiones recurrentes ("Copiar mensaje" siempre).
export const AppCorreo = () => {
  const { pushPrefs, setPushPrefs } = useData();
  const actual = pushPrefs.app_correo || "ambas";
  const elegir = async (v) => {
    try { await setPushPrefs({ app_correo: v }); toast.success("Preferencia guardada"); }
    catch { toast.error("No se pudo guardar."); }
  };
  return (
    <div className="bg-white border border-[#E5DFD5] rounded-2xl p-6 shadow-sm space-y-3" data-testid="perfil-app-correo">
      <h2 className="font-heading text-lg font-bold text-[#1C2421] flex items-center gap-2"><Icons.Mail size={20} className="text-[#3A6B56]" /> Mi app de correo</h2>
      <p className="text-sm text-[#6E7A74]">Para preparar los correos de tus pagos y recordatorios periódicos. «Copiar mensaje» estará siempre disponible.</p>
      {OPCIONES.map(([v, l, sub]) => (
        <label key={v} className="flex items-start gap-3 min-h-[48px] cursor-pointer">
          <input type="radio" data-testid={`app-correo-${v}`} checked={actual === v} onChange={() => elegir(v)} className="w-5 h-5 mt-1 accent-[#3A6B56]" />
          <span><span className="block text-base font-semibold text-[#1C2421]">{l}</span><span className="block text-sm text-[#6E7A74]">{sub}</span></span>
        </label>
      ))}
    </div>
  );
};
